import * as React from 'react';

export function External() {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentFill"
        d="M15,6.414 L9.707,11.707 C9.316,12.098 8.684,12.098 8.293,11.707 C7.902,11.316 7.902,10.684 8.293,10.293 L13.586,5 L11,5 C10.447,5 10,4.552 10,4 C10,3.448 10.447,3 11,3 L15,3 L17,3 L17,9 C17,9.552 16.553,10 16,10 C15.447,10 15,9.552 15,9 L15,6.414 Z M8,4 C8,4.552 7.553,5 7,5 L5,5 L5,15 L15,15 L15,13 C15,12.448 15.447,12 16,12 C16.553,12 17,12.448 17,13 L17,15 C17,16.104 16.104,17 15,17 L5,17 C3.896,17 3,16.104 3,15 L3,5 C3,3.895 3.896,3 5,3 L7,3 C7.553,3 8,3.448 8,4 Z"
      />
    </svg>
  );
}

export function Location() {
  return (
    <svg viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentFill"
        d="M6.095 0A6.102 6.102 0 0 0 0 6.096c0 5.71 5.483 8.909 5.717 9.042a.759.759 0 0 0 .756 0c.234-.133 5.717-3.333 5.717-9.042A6.102 6.102 0 0 0 6.095 0m0 13.572c-1.16-.785-4.571-3.442-4.571-7.476a4.576 4.576 0 0 1 4.571-4.572 4.576 4.576 0 0 1 4.572 4.572c0 4.02-3.415 6.688-4.573 7.476m.001-5.953c-.84 0-1.524-.683-1.524-1.524 0-.84.684-1.524 1.524-1.524s1.524.684 1.524 1.524S6.936 7.62 6.095 7.62m0-4.571a3.05 3.05 0 0 0-3.047 3.047 3.05 3.05 0 0 0 3.047 3.048 3.05 3.05 0 0 0 3.048-3.048 3.05 3.05 0 0 0-3.048-3.047"
      />
    </svg>
  );
}

export function Vocabulary() {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentFill"
        d="M15.2 0H9.6A2.39 2.39 0 0 0 8 .613 2.39 2.39 0 0 0 6.4 0H.8a.8.8 0 0 0-.8.8v12.8a.8.8 0 0 0 .8.8h5.6a.8.8 0 0 1 .8.8.8.8 0 1 0 1.6 0 .8.8 0 0 1 .8-.8h5.6a.8.8 0 0 0 .8-.8V.8a.8.8 0 0 0-.8-.8zm-.8 12.8H9.6c-.282 0-.55.054-.8.143V2.4a.8.8 0 0 1 .8-.8h4.8v11.2zm-8 0H1.6V1.6h4.8a.8.8 0 0 1 .8.8v10.543a2.367 2.367 0 0 0-.8-.143zM4.8 3.2H4a.8.8 0 1 0 0 1.6h.8a.8.8 0 1 0 0-1.6m0 3.2H4A.8.8 0 1 0 4 8h.8a.8.8 0 1 0 0-1.6m6.4-1.6h.8a.8.8 0 1 0 0-1.6h-.8a.8.8 0 1 0 0 1.6m0 3.2h.8a.8.8 0 1 0 0-1.6h-.8a.8.8 0 1 0 0 1.6M4.8 9.6H4a.8.8 0 1 0 0 1.6h.8a.8.8 0 1 0 0-1.6"
      />
    </svg>
  );
}

export function Flag() {
  return (
    <svg viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentFill"
        fillRule="evenodd"
        d="M13.072 8.979L14.085 11H7.427V9.417h3.178a.793.793 0 0 0 .794-.792V6.25h2.686l-1.013 2.02a.789.789 0 0 0 0 .709zM2.305 3.25h7.683V8H3.406L2.305 3.25zM14.848 8.8l1.456-2.843a.782.782 0 0 0-.036-.778.823.823 0 0 0-.697-.38h-4.098V2.4a.81.81 0 0 0-.819-.8H1.842L1.62.627A.824.824 0 0 0 .642.018.801.801 0 0 0 .02.973l3.278 14.4a.817.817 0 0 0 .978.608.801.801 0 0 0 .623-.955L3.663 9.6h2.074V12c0 .442.366.8.82.8h9.014a.824.824 0 0 0 .697-.38.782.782 0 0 0 .036-.779L14.848 8.8z"
      />
    </svg>
  );
}

export function Star() {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 19.5c.177 0 .35-.063.485-.18.246-.21.33-.55.213-.843L14.4 12.363l.268-.237L19.28 8.03c.215-.215.28-.537.163-.818-.115-.28-.39-.462-.693-.462h-5.317l-.135-.286-2.6-5.492C10.582.687 10.306.5 10 .5c-.307 0-.583.187-.71.5L6.568 6.75H1.25c-.304 0-.577.183-.693.463-.116.28-.052.602.142.797l4.9 4.353-.138.33-2.41 5.777c-.118.3-.034.642.21.85.246.21.598.238.862.08L10 15.657l.27.17 5.593 3.566c.12.07.25.107.387.107z"
        stroke="currentFill"
        fill="currentFill"
        fillRule="nonzero"
      />
    </svg>
  );
}

export function Hamburger() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M19 11H1c-.552 0-1-.447-1-1s.448-1 1-1h18c.552 0 1 .447 1 1s-.448 1-1 1zm0-7H1c-.552 0-1-.447-1-1s.448-1 1-1h18c.552 0 1 .447 1 1s-.448 1-1 1zm0 14H1c-.552 0-1-.447-1-1s.448-1 1-1h18c.552 0 1 .447 1 1s-.448 1-1 1z"
        fill="currentFill"
      />
    </svg>
  );
}

export function DragHandleMinor() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        fill="currentFill"
        d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2m0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8m0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14m6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6m0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8m0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14"
      />
    </svg>
  );
}
